// Module
var code = "<template> <require from=\"app/cm/components/household/assessments/assessment-attachments\"></require> <assessment-attachments household-case-id.bind=\"householdCaseId\" config.bind=\"config\"></assessment-attachments> </template> ";
// Exports
module.exports = code;